import { useEffect } from 'react';

interface UseExternalScriptOptions {
  src: string;
  id: string;
  enabled?: boolean;
  async?: boolean;
  defer?: boolean;
}

export function useExternalScript({
  src,
  id,
  enabled = true,
  async = true,
  defer = true,
}: UseExternalScriptOptions) {
  useEffect(() => {
    if (!enabled) return;

    if (document.getElementById(id)) return;

    const script = document.createElement('script');
    script.src = src;
    script.id = id;
    script.type = 'text/javascript';

    if (async) script.async = true;
    if (defer) script.defer = true;

    document.body.appendChild(script);

    return () => {
      const existing = document.getElementById(id);
      if (existing) {
        existing.remove();
      }
    };
  }, [src, id, enabled, async, defer]);
}
